<template>
    <div>
        <Table :no-data-text="$t('common.noData')" :columns="columns" :data="tableCommandDate" style="width: 100.1%;" height="500" :loading="commandLoadings">
            <template slot-scope="{row,index}" slot="detail">
                <span @click="doDelete(index)">
                    <Button type="info" size="small" @click="rowClick(row)">{{ $t('alarms.common.details') }}</Button>
                   <!--  <Button type="error" size="small"  @click="cancelCommandModal = true">取消命令</Button>
                    <Button type="warning" size="small"  @click="returnCommandsModal = true">重新运行命令</Button> -->
                </span>
            </template>
        </Table>

        <!-- 取消命令 -->
        <Modal v-model="cancelCommandModal" width="450" :mask-closable="false" :styles="{top:'200px'}">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>取消命令  39902398-ce1d-45b9-b711-634d4c8b8045</span>
            </p>
            <div>
                <p>您可以尝试取消此命令。但是，我们无法保证该命令将终止并且基础流程将停止。是否确实要取消此命令？</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="modal_loading" :disabled="isDisable" @click="removeCommand()">取消命令</Button>
            </div>
        </Modal>

        <!-- 重新运行命令 -->
        <Modal v-model="returnCommandsModal" width="450" :mask-closable="false" :styles="{top:'200px'}">
            <p slot="header" style="color:#f90;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>重新运行命令</span>
            </p>
            <div style="text-align: center;">
                <p>您是否要使用完全相同的输入重新运行命令？</p>
                <p>39902398-ce1d-45b9-b711-634d4c8b8045.</p>
            </div>
            <div slot="footer">
                <Button type="warning" size="large" long :loading="modal_loadings" :disabled="isDisables" @click="returnCommands()">重新运行命令</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    var tableCommandVue = {};
    export default {
        name: 'TableCommand',
        data () {
            return {
                accountIdSearchKey:'',
                regionSearchKey:'',
                commandId:'',
                commandLoadings:false,
                modal_loading: false, 
                cancelCommandModal:false,
                isDisable: false, //取消命令
                modal_loadings:false,
                isDisables: false,
                returnCommandsModal:false, //重新运行命令
                columns: [
                    {
                        title: this.$t('PatchEasy.PatchCmd.cmdID'),
                        key: 'commandId'
                    },
                    {
                        title: this.$t('alarms.common.status'),
                        key: 'status'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.requestDate'),
                        key: 'requestedDateTime'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.fileName'),
                        key: 'documentName'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.comment'),
                        key: 'comment'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.tgt'),
                        key: 'targetCount'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.error'),
                        key: 'errorCount'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.submitDelay'),
                        key: 'deliveryTimedOutCount'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.complete'),
                        key: 'completedCount'
                    },
                    {
                        title: this.$t('common.operation'),
                        slot: 'detail'
                    }
                ],
                tableCommandDate:[]
            }
        },
        beforeCreate: function() {
            tableCommandVue = this
        },
        methods: {
            showAll: function(accountIdSearchKey,regionSearchKey,commandId){
                tableCommandVue.accountIdSearchKey = accountIdSearchKey;
                tableCommandVue.regionSearchKey = regionSearchKey;
                tableCommandVue.commandId = commandId;
                tableCommandVue.getCommandData();
            },
            // 分页显示数据
            /****************************************************/
            getCommandData:function() {
                this.commandLoadings = true;
                //分页
                this.$api.policy.listCommands({
                    "awssmCommandRequestDTO" : {
                        "maxResults" : 50,
                        "executionStage" : "Executing",
                        "commandId" : tableCommandVue.commandId
                    },
                    "accountId" : tableCommandVue.accountIdSearchKey,
                    "regionString" : tableCommandVue.regionSearchKey
                })
                .then(res => {
                    this.tableCommandDate = res.data;
                    this.commandLoadings = false;
                });
            },
            /**********************************详情***********************************/
            rowClick:function(row){
                //分页
                this.$api.policy.getCommandDetail({
                    "awssmCommandRequestDTO" : {
                        "maxResults" : 50,
                        "executionStage" : "Executing",
                        "commandId" : row.commandId,
                        "deatils" : true
                    },
                    "accountId" : tableCommandVue.accountIdSearchKey,
                    "regionString" : tableCommandVue.regionSearchKey                 
                })
                .then(res => {
                    let $params = {
                        commandId: res.data.commandId,
                        commandStatusDTOs:res.data.commandStatusDTOs,
                        commandTargetsAndOutputsDTOs: res.data.commandTargetsAndOutputsDTOs,
                        documentName: res.data.documentName,
                        comment: res.data.comment,
                        documentVersion: res.data.documentVersion,
                        requestedDateTime: res.data.requestedDateTime,
                        accountIdSearchKey:tableCommandVue.accountIdSearchKey,
                        regionSearchKey:tableCommandVue.regionSearchKey,
                        commandParametersDTO:res.data.commandParametersDTO
                        // version:res.data.commandParametersDTO.version[0],
                        // allowDowngrade:res.data.commandParametersDTO.allowDowngrade[0]
                    }
                    this.$router.push({path:'/patchManagement/commandDetail',query: $params});
                });
                
            },
            /**********************************取消命令***********************************/
            doDelete: function(index){
                this.lineIndex=index;
                this.alertRuleName=this.tableCommandDate[index].alertRuleName;
            },
            removeCommand: function(){
                this.isDisable = true;  //开始可以点击
                var lineIndex=this.lineIndex;
                //取消命令
                this.$api.alertRule.deleteAlertRule("id",this.tableCommandDate[lineIndex].id)
                .then(res => {
                    this.modal_loading = true;
                    setTimeout(() => {
                        // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                        //21条  3页  2*10+1时删除
                        if(lineIndex==0&&((this.current-1)*this.pageSize+1)==this.dataTotal){
                            this.current=this.current-1;
                        }
                        this.dataTotal=this.dataTotal-1;
                        tableCommandVue.getCommandData();
                        this.isDisable = false;
                        this.modal_loading = false;
                        this.cancelCommandModal = false;
                        this.$Message.success('取消命令成功');
                    }, 1000);
                })
            },
            /**********************************重新运行命令***********************************/
            returnCommands: function(){
                this.isDisables = true;  //开始可以点击
                var lineIndex=this.lineIndex;
                //重新运行命令
                this.$api.alertRule.deleteAlertRule("id",this.tableCommandDate[lineIndex].id)
                .then(res => {
                    this.modal_loadings = true;
                    setTimeout(() => {
                        // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                        //21条  3页  2*10+1时删除
                        if(lineIndex==0&&((this.current-1)*this.pageSize+1)==this.dataTotal){
                            this.current=this.current-1;
                        }
                        this.dataTotal=this.dataTotal-1;
                        tableCommandVue.getCommandData();
                        this.isDisables = false;
                        this.modal_loadings = false;
                        this.returnCommandsModal = false;
                        this.$Message.success('重新运行命令成功');
                    }, 1000);
                })
            }
        }
    }
</script>
<style scoped>
    .ivu-page
    {
        margin-top: 10px !important;
        margin-bottom: 30px !important;
    }
    /* 滚动条 */
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #ccc;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
        background: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
        background-color: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowX{
        overflow-x: hidden !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/patch_management/patch_command_parameters/TableCommand.vue